/* INFINITAMENTE — minimal theme behaviour */
(function () {
  'use strict';

  // Header scroll state
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const onScroll = () => {
      header.dataset.scrolled = window.scrollY > 50 ? 'true' : 'false';
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile menu toggle
  const menuToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.dataset.open === 'true';
      mobileMenu.dataset.open = open ? 'false' : 'true';
      menuToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      document.body.style.overflow = open ? '' : 'hidden';
    });
    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileMenu.dataset.open = 'false';
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // Product gallery thumbnails
  const galleries = document.querySelectorAll('[data-product-gallery]');
  galleries.forEach((gallery) => {
    const mainImages = gallery.querySelectorAll('[data-main-image]');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.thumb;
        thumbs.forEach((t) => t.setAttribute('aria-current', t === thumb ? 'true' : 'false'));
        mainImages.forEach((img) => {
          if (img.dataset.mainImage === id) {
            img.removeAttribute('hidden');
          } else {
            img.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  // Product variant selection
  const productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach((form) => {
    const variantInput = form.querySelector('[name="id"]');
    const priceEl = form.querySelector('[data-product-price]');
    const compareEl = form.querySelector('[data-product-compare]');
    const submit = form.querySelector('[data-add-to-cart]');
    const submitText = submit ? submit.querySelector('[data-add-to-cart-text]') : null;
    const variantsScript = form.querySelector('[data-variants-json]');
    let variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (e) { variants = []; }

    const optionGroups = form.querySelectorAll('[data-option-group]');

    function getSelectedOptions() {
      const opts = [];
      optionGroups.forEach((group) => {
        const sel = group.querySelector('[aria-pressed="true"]');
        opts.push(sel ? sel.dataset.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find((v) => {
        return v.options.every((o, i) => o === opts[i]);
      });
    }

    function updateVariant() {
      const opts = getSelectedOptions();
      const variant = findVariant(opts);
      if (variant) {
        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
            compareEl.textContent = variant.compare_at_price;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submit) {
          submit.disabled = !variant.available;
          if (submitText) submitText.textContent = variant.available
            ? (submit.dataset.labelAdd || 'Adicionar ao carrinho')
            : (submit.dataset.labelSoldout || 'Esgotado');
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } else {
        if (submit) {
          submit.disabled = true;
          if (submitText) submitText.textContent = (submit.dataset.labelUnavailable || 'Indisponível');
        }
      }
    }

    optionGroups.forEach((group, idx) => {
      const buttons = group.querySelectorAll('[data-option-pill]');
      buttons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
          updateVariant();
        });
      });
    });
  });

  // Cart line item quantity changes (cart page)
  const cartItems = document.querySelectorAll('[data-cart-item]');
  cartItems.forEach((item) => {
    const inc = item.querySelector('[data-qty-inc]');
    const dec = item.querySelector('[data-qty-dec]');
    const input = item.querySelector('[data-qty-input]');
    const form = item.closest('form');
    if (!input) return;

    const change = (delta) => {
      const next = Math.max(0, parseInt(input.value, 10) + delta);
      input.value = next;
      if (form) form.submit();
    };
    if (inc) inc.addEventListener('click', () => change(1));
    if (dec) dec.addEventListener('click', () => change(-1));
  });
})();
